import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IListaAnhos, IListaPeriodos } from 'src/app/interfaces/ponderaciones';
import { IAperturaSecciones, IBodyApertura, IBodyCierre, ICierreSecciones, IEstados, IListaMasivaRes, IListaRes, IListaSecciones, IReqBodyReintentoCierreSecciones, IResDetalleErrSap, IResListaErroresSap } from 'src/app/interfaces/secciones';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MantenedorSeccionesService {

  constructor(
    private readonly http: HttpClient
  ) { }

  getHeaders(): HttpHeaders {
    return new HttpHeaders();
  }

  getFiltrosAnhos(): Observable<IListaAnhos> {
    const url = `${environment.endpointAdministrativo}/v1/ponderacion/individual/obtener-anyos`
    return this.http.get<IListaAnhos>(url, { headers: this.getHeaders() })
  }

  getFiltrosPeriodos(anho: number): Observable<IListaPeriodos> {
    const url = `${environment.endpointAdministrativo}/v1/ponderacion/individual/obtener-periodos?anyo=${anho}`
    return this.http.get<IListaPeriodos>(url, { headers: this.getHeaders() })
  }

  getFiltrosSedes(userId: number): Observable<any> {
    const url = `${environment.endpointAdministrativo}/v1/ponderacion/individual/obtener-sedes?usuario-id=${userId}`
    return this.http.get<any>(url, { headers: this.getHeaders() })
  }

  getFiltrosSecciones(anyo: number, periodoId: number, sedeId: number): Observable<IListaSecciones> {
    const url = `${environment.endpointAdministrativo}/v1/seccion/buscar-secciones?anyo=${anyo}&periodo-id=${periodoId}&sede-id=${sedeId}`
    return this.http.get<IListaSecciones>(url, { headers: this.getHeaders() })
  }

  getEstados(): Observable<IEstados> {
    const url = `${environment.endpointAdministrativo}/v1/seccion/buscar-estados`
    return this.http.get<IEstados>(url, { headers: this.getHeaders() })
  }

  getLista(body: any, pageSize: number = 10, pageNumber: number = 1): Observable<IListaRes> {
    const seccionParams = body.seccionId !== 0 ? `&seccion-id=${body.seccionId}` : ''
    const estadoParams = body.estadoId !== 0 ? `&estado-id=${body.estadoId}` : ''
    const url = `${environment.endpointAdministrativo}/v1/seccion/obtenerLista?anyo=${body.anyo}&periodo-id=${body.periodoId}&sede-id=${body.sedeId}${seccionParams}${estadoParams}&page-size=${pageSize}&page-no=${pageNumber}`
    return this.http.get<IListaRes>(url, { headers: this.getHeaders() })
  }

  getListaMasiva(anyo: number, periodoId: number, sedeId: number, pageSize: number = 10, pageNumber: number = 1): Observable<IListaMasivaRes> {
    const url = `${environment.endpointAdministrativo}/v1/proceso-masivo/obtenerLista?anyo=${anyo}&periodo-id=${periodoId}&sede-id=${sedeId}&page-size=${pageSize}&page-no=${pageNumber}`;
    return this.http.get<IListaMasivaRes>(url, { headers: this.getHeaders() })

  }

  postAperturaSecciones(body:IBodyApertura): Observable<IAperturaSecciones> {
    const url = `${environment.endpointAdministrativo}/v1/seccion/aperturaSecciones`;
    return this.http.post<IAperturaSecciones>(url, body, { headers: this.getHeaders() })
  }
  postCierreSecciones(body: IBodyCierre): Observable<ICierreSecciones> {
    const url = `${environment.endpointAdministrativo}/v1/seccion/cierreSecciones`;
    return this.http.post<ICierreSecciones>(url, body, { headers: this.getHeaders() })
  }

  obtenerListaErroresSap(anyo: number, periodoId: number, sedeId: number, seccionId: number, pageSize: number = 10, pageNumber: number = 1): Observable<IResListaErroresSap> {
    const filtrosOpcionales: string = seccionId != 0 ? `&seccion-id=${seccionId}` : ''
    const url = `${environment.endpointAdministrativo}/v1/seccion/errores/obtenerLista?anyo=${anyo}&periodo-id=${periodoId}&sede-id=${sedeId}${filtrosOpcionales}&page-size=${pageSize}&page-no=${pageNumber}`;
    return this.http.get<IResListaErroresSap>(url, { headers: this.getHeaders() })
  }

  obtenerDetalleErrorSap(seccionEvaluacionId: number): Observable<IResDetalleErrSap> {
    const url = `${environment.endpointAdministrativo}/v1/seccion/errores/obtenerDetalle?seccion-evaluacion-id=${seccionEvaluacionId}`;
    return this.http.get<IResDetalleErrSap>(url, { headers: this.getHeaders() })
  }

  postReintentoCierreSecciones(body: IReqBodyReintentoCierreSecciones ): Observable<ICierreSecciones> {
    const url = `${environment.endpointAdministrativo}/v1/seccion/reintentoCierreSecciones`;
    return this.http.post<ICierreSecciones>(url, body, { headers: this.getHeaders() })
  }
}
